import { render, staticRenderFns } from "./drawerCardDescribe.vue?vue&type=template&id=661e0356&"
import script from "./drawerCardDescribe.vue?vue&type=script&lang=js&"
export * from "./drawerCardDescribe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports